import { Link } from "react-router-dom";

export const ProjectCard = ({ p, aspect = "aspect-[4/5]", index = 0 }) => (
  <Link to={`/progetti/${p.slug}`} className="group block" data-testid={`project-card-${p.slug}`}>
    <div className={`relative overflow-hidden bg-ink/10 ${aspect}`}>
      <img src={p.cover} alt={`${p.title}: immagine indicativa`} loading="lazy" decoding="async" className="photo photo-hover absolute inset-0 h-full w-full object-cover group-hover:scale-[1.04]" />
      {p.caseStudy && <span className="absolute left-4 top-4 bg-paper/90 px-2.5 py-1 text-[11px] font-semibold uppercase tracking-[0.16em] text-teal">Case study</span>}
      <span className="absolute bottom-4 right-4 flex h-14 w-14 scale-75 items-center justify-center rounded-full bg-mint font-serif text-sm text-teal opacity-0 transition-[opacity,transform] duration-500 group-hover:scale-100 group-hover:opacity-100" aria-hidden="true">Apri</span>
    </div>
    <div className="mt-5 flex items-start justify-between gap-6">
      <div>
        <p className="text-xs uppercase tracking-[0.18em] text-teal">{p.sector}{p.place ? ` · ${p.place}` : ""}</p>
        <h3 className="mt-2 text-2xl leading-tight md:text-3xl">{p.title}</h3>
        <p className="mt-2 font-serif text-lg leading-snug text-ink/75">{p.tagline}</p>
      </div>
      <span className="font-serif text-sm text-ink/60">{String(index + 1).padStart(2, "0")}</span>
    </div>
    <p className="mt-3 text-xs uppercase tracking-[0.14em] text-ink/65">{p.tags.join(" · ")}</p>
  </Link>
);
